import { useEffect, type ReactNode } from 'react';
import { ForbiddenState } from '../../../components/system-states/SystemState';
import { router } from '../../../router';
import { useCanView, useRequiredSession } from '../../../stores/session';
import { useModules } from '../../../lib/modules';
import { landingFor } from '../home-landing';
import { WorkspacePage } from './WorkspacePage';

/**
 * `/` — the Dashboard (DECISIONS-LOG S25–S28 Q13: by role). A recruiter lands on their
 * workspace; the HR Lead on the command center (S28). Someone with no reports at all — a
 * panelist, an invigilator — is taken to the first screen their module bar offers, rather than
 * shown a page they cannot use. R1 (§L34): with Reports and the Recruiter dashboard switched off
 * (the defaults) that first screen is the job list — "My jobs".
 */
export function HomePage(): ReactNode {
  const canView = useCanView('reports_own');
  const isHrLead = useCanView('reports_all_staff');
  const session = useRequiredSession();
  const modules = useModules();
  const elsewhere = landingFor(session, modules, isHrLead && modules.reports, canView && modules.workspace);

  useEffect(() => {
    // A route change inside the app, not a page load (§5a rule 7).
    if (elsewhere) router.history.replace(elsewhere);
  }, [elsewhere]);

  if (elsewhere) return null;
  if (canView && modules.workspace) return <WorkspacePage />;
  return <ForbiddenState resource="any screen yet" contact="Your admin" />;
}
